import {useCallback} from 'react'

import {TableRowHeight, ViewTypeParam} from '../api/view/contracts'
import {
  getTableRowHeightAlignItems,
  getTableRowHeightPaddingY,
  isTableRowHeight,
  ROW_HEIGHT_VALUES,
} from '../helpers/table-row-height'
import {useEnabledFeatures} from './use-enabled-features'
import {ViewStateActionTypes} from './use-view-state-reducer/view-state-action-types'
import {useViews} from './use-views'

type UseTableRowHeight = {
  rowHeight: TableRowHeight
  rowHeightPx: number
  rowHeightAlignItems: 'center' | 'flex-start'
  rowHeightPaddingY: number
  setRowHeight: (viewNumber: number, rowHeight: TableRowHeight) => void
}

export const useTableRowHeight = (): UseTableRowHeight => {
  const {currentView, viewStateDispatch} = useViews()
  const {memex_table_row_height} = useEnabledFeatures()

  const configuredRowHeight = currentView?.localViewState?.layoutSettings?.table?.rowHeight
  const rowHeight =
    memex_table_row_height &&
    currentView?.localViewState?.layout === ViewTypeParam.Table &&
    isTableRowHeight(configuredRowHeight)
      ? configuredRowHeight
      : TableRowHeight.Single

  const setRowHeight = useCallback(
    (viewNumber: number, newRowHeight: TableRowHeight): void => {
      viewStateDispatch({
        type: ViewStateActionTypes.SetTableRowHeight,
        viewNumber,
        rowHeight: newRowHeight,
      })
    },
    [viewStateDispatch],
  )

  return {
    rowHeight,
    rowHeightPx: ROW_HEIGHT_VALUES[rowHeight],
    rowHeightAlignItems: getTableRowHeightAlignItems(rowHeight),
    rowHeightPaddingY: getTableRowHeightPaddingY(rowHeight),
    setRowHeight,
  }
}
